var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.20971 4.13715H6.67917V10.864C6.67917 10.9515 6.75075 11.0231 6.83825 11.0231H8.03131C8.1188 11.0231 8.19039 10.9515 8.19039 10.864V4.13715H9.66382C9.79704 4.13715 9.87062 3.98404 9.78909 3.88064L7.56204 1.06103C7.54716 1.04202 7.52814 1.02665 7.50644 1.01607C7.48474 1.0055 7.46091 1 7.43677 1C7.41262 1 7.3888 1.0055 7.36709 1.01607C7.34539 1.02665 7.32638 1.04202 7.31149 1.06103L5.08444 3.87865C5.00292 3.98404 5.07649 4.13715 5.20971 4.13715ZM14.7145 10.2675H13.5214C13.4339 10.2675 13.3623 10.3391 13.3623 10.4266V13.4888H1.51121V10.4266C1.51121 10.3391 1.43963 10.2675 1.35214 10.2675H0.159075C0.0715838 10.2675 0 10.3391 0 10.4266V14.3637C0 14.7157 0.284347 15 0.636301 15H14.2372C14.5892 15 14.8735 14.7157 14.8735 14.3637V10.4266C14.8735 10.3391 14.8019 10.2675 14.7145 10.2675Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8735,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.2bd21aec.svg";
export { ForwardRef as ReactComponent };